// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-page[data-v-7e419254]{margin-top:168px;z-index:6;position:relative;display:flex;flex-direction:column;align-items:stretch;justify-content:flex-start;height:calc(100vh - 164px);overflow-x:hidden}@media(max-width:960px){.search-page[data-v-7e419254]{height:auto;margin-top:180px}}.search-page[data-v-7e419254],.search-page *[data-v-7e419254]{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
